module.exports = __webpack_public_path__ + "static/img/selfAdd_02.9d0821e3.svg";